import { FC, useContext, useEffect } from 'react';
import { getAgeOptions } from './PatientAgeRule.consts';
import { OperatinonsSign, Operations } from '@src/api';
import { Stack } from '@mui/system';
import { OperationButtonWithTooltip } from '@components/OperationButtonWithTooltip';
import { useFormContext } from 'react-hook-form';
import { FormAutocompleteField } from '@components/FormFields';
import { RuleFactoryChildrenProps } from '../types';
import { DisableContext } from '@pages/Selection/components/DisableContext';
import { DisabledRuleItem } from '@components/DisabledRuleItem';
import { replaceCebabCase } from '@src/utils';

export const PatientAgeRule: FC<RuleFactoryChildrenProps> = ({ prefix, children, dataTestId }) => {
  const { control, setValue, watch } = useFormContext();
  const disabled = useContext(DisableContext);

  const onChangeOperation = (val: Operations) => {
    setValue(`${prefix}.compareOperator`, val);
  };

  const [opearationValue, age] = watch([`${prefix}.compareOperator`, `${prefix}.age`]);

  useEffect(() => {
    if (!opearationValue) {
      setValue(`${prefix}.compareOperator`, Operations.Equals);
      setValue(`${prefix}.age`, '');
    }
  }, [opearationValue, prefix, setValue]);

  return disabled ? (
    <DisabledRuleItem name="Patient's age in years" value={`${OperatinonsSign[opearationValue]} ${age} years old`} />
  ) : (
    <>
      <OperationButtonWithTooltip
        onChangeOperation={onChangeOperation}
        opeartionValue={(opearationValue as unknown as Operations) || ''}
        disabled={disabled}
        dataTestId={`${dataTestId}_${replaceCebabCase(prefix)}`}
      />
      <Stack flexGrow={1}>
        <FormAutocompleteField
          control={control}
          name={`${prefix}.age`}
          options={getAgeOptions}
          placeholder="Select"
          maxLenght={3}
          disabled={disabled}
          disableClearIcon
        />
      </Stack>
      {children}
    </>
  );
};
